import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as CONST from '../constants';
import GiftCardEditForm from './GiftCardEditForm';
import Button from '../audi-ui-components/Button';
import Cancel from '../audi-ui-components/icons/Cancel';

import fallbackimg from '../images/experience.png';
import giftcardtile from '../images/AA11242-Audi-driving-experience-voucher-no-price.jpg';

class CartItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isEditing: false
        }
    }

    formatDate(d, includeTime) {
        let opts = {
          weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'
        };
        if (includeTime) {
          opts = {
            weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: true
          };
        }
        const newDate = new Date(d);
        const dateFormat = new Intl.DateTimeFormat('en-GB', opts);
        return dateFormat.format(newDate);
    }

    render() {
        const {item} = this.props;
        if (item.type === CONST.ITEM_EXPERIENCE) {
            let _imgDesktop = item.program.thumbnail || fallbackimg;
            let _imgMobile = item.program.mobileThumbnail || item.program.thumbnail || fallbackimg;
            let isSameDay = new Date(item.experience.startDate).toDateString() === new Date(item.experience.endDate).toDateString();
            return (
                <div key={item.id} className="cart-item">
                    <div className="row">
                        <div className="col-3 cart-item--thumbnail">
                            <img className="d-none d-medium-block" src={_imgDesktop} alt="" />
                            <img className="d-medium-none" src={_imgMobile} alt="" />
                        </div>
                        <div className="col-12 col-xsmall-9">
                            <div className="row">
                                <div className="col-12 col-xsmall-8 order-3 order-xsmall-2 cart-item--description">
                                    <p><b>Experience:</b><br />{item.program.name}</p>
                                    {item.experience && <p>
                                        <b>Circuit:</b> {item.experience.venue.location}<br />
                                        <b>Date + Time:</b> {this.formatDate(item.experience.startDate, isSameDay)} {!isSameDay && <> - {this.formatDate(item.experience.endDate)}</>}
                                    </p>}
                                </div>
                                <div className="col order-1 order-xsmall-2 cart-item--amount">
                                    <b>${item.amount}</b>{item.hasGst && <><small>incl. GST</small></>}{!item.hasGst && <><small>excl. GST</small></>}
                                </div>
                                {item.id && <div className="col-auto order-2 order-xsmall-3 cart-item--cancel">
                                    <Button variant="icon" onClick= {() => {this.props.removeFromCart(item.id);}} icon={<Cancel small />} />
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        if (item.type === CONST.ITEM_GIFT_CARD) {
            return (
                <div key={item.id} className="cart-item">
                    <div className="row">
                        <div className="col-3 cart-item--thumbnail">
                            <img src={giftcardtile} alt="" />
                        </div>
                        <div className="col-12 col-xsmall-9">
                            <div className="row">
                                <div className="col-12 col-xsmall-8 order-3 order-xsmall-1 cart-item--description">
                                    <p><b>{CONST.GIFT_CARD_NAME}</b></p>
                                    {!this.state.isEditing && <div>
                                        {item.recipientName && <p><b>Recipient:</b> {item.recipientName}</p>}
                                        <p><b>Email to:</b> {item.recipientEmail ? item.recipientEmail : 'myself'}</p>
                                        {item.senderMessage && <p><b>Message:</b> {item.senderMessage}</p>}
                                        <p><Button variant="secondary" onClick={() => { this.setState({isEditing: true}); }}>Edit {CONST.GIFT_CARD_NAME}</Button></p>
                                    </div>}
                                </div>
                                <div className="col order-1 order-xsmall-2 cart-item--amount">
                                    <b>${item.amount}</b><small>incl. GST</small>
                                </div>
                                <div className="col-auto order-2 order-xsmall-3 cart-item--cancel">
                                    <Button variant="icon" onClick= {() => {this.props.removeFromCart(item.id);}} icon={<Cancel small />} />
                                </div>
                            </div>
                            {this.state.isEditing && <GiftCardEditForm cartItem={item} close={() => { this.setState({isEditing: false}); }} />}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default CartItem;
